import { colors } from '@lmc/common/constants'
import { Popover } from '@lmc/ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { Icon } from '../../../../../components/generic'
import { getShowAlert } from './utils'

/**
@description Renders the icon for StockListItem.

@param {object} medication. The medication whose stock
level is being displayed.

@returns {function} StockAlertIcon
*/

export function StockAlertIcon(props) {
  const {
    medication,
    medication: { stockAlertLevel }
  } = props

  const showAlert = getShowAlert(medication)

  return (
    <Popover
      content={showAlert ? 'Stock level low' : 'Stock level ok'}
      placement="top"
    >
      <div style={styles.icon}>
        <Icon
          name={showAlert ? 'incident' : 'tick-in-circle'}
          fill={
            stockAlertLevel
              ? showAlert
                ? colors.red
                : colors.successgreen
              : null
          }
          size={24}
        />
      </div>
    </Popover>
  )
}

StockAlertIcon.propTypes = {
  medication: PropTypes.object.isRequired
}

const styles = {
  icon: {
    height: 24,
    marginLeft: 10
  }
}

export default StockAlertIcon
